import { useParams, useSearchParams } from "react-router-dom";
import { useGetCalculationStepDataQuery } from "./calculationStepReducer";
import {
  MotifErrorMessage,
  MotifIcon,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import CalculationStepHeaderEdit from "./CalculationStepHeaderEdit";
import { useState } from "react";
import { renderAccountList } from "./Form/calculationSummaryHelper";
import { CalculationStepViewSummary } from "./CalculationStepViewSummary";
import {
  useGetDistributionByCaseIDQuery,
  useGetDistributionSummaryByIdQuery,
  useGetStepCalculationDataByIdApiDataQuery,
} from "@/services/distribution/distributionReducers";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useSelector } from "react-redux";
import { useCase } from "@/features/case/use-case";
import { DistributionStepContext } from "../summery/DistributionContext";
import { ActiveTabsOrder } from "@/menuData";
import { maxPageSize } from "@/Constant";
const CalculationStepSummary = () => {
  const { caseId, distributionId, stepId } = useParams<{
    caseId: string;
    distributionId: string;
    stepId: string;
  }>();
  const caseData = useCase();
  const [searchParams] = useSearchParams();
  const navigatedFrom = searchParams.get("navigatedFrom");

  const { t } = useTranslation();
  const [editForm, setEditForm] = useState(false);
  let discardDetails = useSelector((e: any) => e.discardChangesDatas.data);
  const [showDiscardPopup, setShowDiscardPopup] = useState(false);

  function handleClose() {
    setEditForm(false);
    setShowDiscardPopup(false);
  }
  function handleReject() {
    setShowDiscardPopup(false);
  }
  const {
    data: accountData,
    isLoading: isLoadingAccount,
    isError: loadingAccountError,
  } = useGetCalculationStepDataQuery({ caseId: caseId });
  const {
    data: dataByStepId,
    refetch,
    isError: getSetDataError,
    error: stepDataError,
  } = useGetStepCalculationDataByIdApiDataQuery({ stepId, distributionId });
  const { data, isLoading, isError } = useGetDistributionSummaryByIdQuery(
    {
      id: distributionId,
    },
    { skip: false }
  );

  const {
    data: distributionList,
    isLoading: isLoadingDistributionList,
    isError: loadingDistributionError,
  } = useGetDistributionByCaseIDQuery({
    CaseId: caseId,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "DistributionDate",
    PageNumber: 1,
    PageSize: maxPageSize,
  });
  let firstDistributionYear: any = undefined;
  let currentDistributionYear = data?.distributionDate
    ? new Date(data?.distributionDate).getFullYear()
    : null;
  let showRelativeYearOption = false;
  if (currentDistributionYear) {
    distributionList?.results.find((dis: any) => {
      if (dis?.distributionDate) {
        let getDustributionDate = new Date(dis?.distributionDate);
        firstDistributionYear = getDustributionDate.getFullYear();
        return true;
      }
      return false;
    });
  }
  if (
    currentDistributionYear &&
    firstDistributionYear &&
    currentDistributionYear > firstDistributionYear
  ) {
    showRelativeYearOption = true;
  }
  const [resultSettingTab, setResultSettingTab] = useState(false);
  const [currentFloorAmount, setCurrentFloorAmount] = useState(false);
  let distributionStepContextJson = {
    showRelativeYearOption: showRelativeYearOption,
    currentDistributionYear: currentDistributionYear,
    cap_floor_amount: (flag: boolean) => setCurrentFloorAmount(flag),
    resultSetting_tab: (flag: boolean) => setResultSettingTab(flag),
    distributionStatus: data?.distributionStatus || "",
  };
  const accountList = renderAccountList(accountData ? accountData : []);

  if (isLoadingAccount || isLoading || isLoadingDistributionList) {
    return <div>{t("global.globalNotifications.loadingMessage")}</div>;
  }
  let errorData: any = stepDataError;
  if (
    loadingAccountError ||
    isError ||
    loadingDistributionError ||
    getSetDataError
  ) {
    return getSetDataError && errorData?.data?.message ? (
      <MotifErrorMessage>{errorData?.data?.message}</MotifErrorMessage>
    ) : (
      <MotifErrorMessage>
        {t("global.globalNotifications.wentWrong")}
      </MotifErrorMessage>
    );
  }

  const breadcrumbItems = [
    {
      label: "Back",
      elementKey: "Back",
      text: caseData?.caseName,
      url: `/case/${caseId}?activeTab=${
        navigatedFrom === "paymentGrid"
          ? ActiveTabsOrder.PAYMENT
          : ActiveTabsOrder.DISTRIBUTION
      }`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation: editForm,
    },
    {
      label: "Back",
      elementKey: "Back",
      text: data?.name,
      url: `/case/${caseId}/distribution/${distributionId}?activeTab=1${
        navigatedFrom === "paymentGrid" ? "&navigatedFrom=paymentGrid" : ""
      }`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation: editForm,
    },
    {
      label: "Back",
      elementKey: "Back",
      text: dataByStepId?.stepName,
      url: `/case/${caseId}/distribution/${distributionId}?activeTab=1`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation: editForm,
      disabled: true,
    },
  ];
  const summaryData = {
    stepName: dataByStepId?.stepName || "",
    account: dataByStepId?.accountId || "",
    subAccount: dataByStepId?.subAccountId || "",
    description: dataByStepId?.description || "",
    payables: dataByStepId?.isMemo === true ? "1" : "0",
    calculationStepId: dataByStepId?.id || "",
    comment: dataByStepId?.comment,
    calculationGroupBy: dataByStepId?.calculationGroupBy,
    payeeTypeId: dataByStepId?.payeeTypeId,
    isCapZeroLimit: dataByStepId?.isCapZeroLimit,
    isFloorZeroLimit: dataByStepId?.isFloorZeroLimit,
    limitAmountOrder: dataByStepId?.limitAmountOrder,
  };

  return (
    <>
      <div
        onClick={() => {
          if (
            discardDetails.editMode &&
            !resultSettingTab &&
            !currentFloorAmount
          ) {
            setShowDiscardPopup(true);
          } else {
            setEditForm(false);
          }
        }}
      >
        {isLoading ? (
          <MotifProgressLoader variant="default"></MotifProgressLoader>
        ) : (
          <Breadcrumb
            items={breadcrumbItems}
            ariaLabel="Breadcrumb navigation"
          />
        )}
      </div>
      <CalculationStepHeaderEdit
        create={false}
        selectedStep={dataByStepId}
        distributionId={distributionId}
        timeZone={caseData?.abbreviation}
        distributionName={data?.name}
      />
      <DistributionStepContext.Provider value={distributionStepContextJson}>
        <CalculationStepViewSummary
          dataByStepId={dataByStepId}
          summaryData={{ ...summaryData, distributionName: data?.name || "" }}
          setEditForm={setEditForm}
          accountList={accountList}
          caseId={caseId || ""}
          distributionId={distributionId || ""}
          stepId={stepId || ""}
          editForm={editForm}
          refetch={refetch}
          showRelativeYearOption={showRelativeYearOption}
        />
      </DistributionStepContext.Provider>
      <ConfirmationModal
        isVisible={showDiscardPopup}
        setIsVisible={handleClose}
        cancelBtnApproveHandler={handleClose}
        cancelBtnRejectHandler={handleReject}
      />
    </>
  );
};

export default CalculationStepSummary;
